import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const HERO_DEFAULT = "https://images.unsplash.com/photo-1677921755291-c39158477b8e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900";
export const LOGO_DEFAULT = "/img/logo.png";
export const BRANDING_DEFAULT = {
  hero_image: "", logo_image: "", shop_name: "POKYA", shop_tagline: "Restaurant", welcome_text: "Selamat Datang ke",
  hero_title: "Pokya Restaurant", hero_subtitle: "Pesan menu kegemaran anda dengan mudah!", search_placeholder: "Cari menu...",
};
const KEY = "alfaz_branding";
export const mediaSrc = (v) => (v?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${v}` : v);

export function useBranding() {
  const [b, setB] = useState(() => {
    try { return { ...BRANDING_DEFAULT, ...JSON.parse(localStorage.getItem(KEY) || "{}") }; } catch { return BRANDING_DEFAULT; }
  });
  useEffect(() => {
    api.get("/public/branding").then((r) => {
      setB({ ...BRANDING_DEFAULT, ...r.data });
      try { localStorage.setItem(KEY, JSON.stringify(r.data)); } catch { /* storage full */ }
    }).catch(() => {});
  }, []);
  return b;
}

export function resizeImage(file, maxW, type = "image/jpeg", square = false, quality = 0.82) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const side = Math.min(img.width, img.height);
      const [sx, sy, sw, sh] = square ? [(img.width - side) / 2, (img.height - side) / 2, side, side] : [0, 0, img.width, img.height];
      const scale = Math.min(1, maxW / sw);
      const c = document.createElement("canvas");
      c.width = Math.round(sw * scale);
      c.height = Math.round(sh * scale);
      c.getContext("2d").drawImage(img, sx, sy, sw, sh, 0, 0, c.width, c.height);
      URL.revokeObjectURL(img.src);
      resolve(c.toDataURL(type, quality));
    };
    img.onerror = () => reject(new Error("Fail bukan gambar yang sah"));
    img.src = URL.createObjectURL(file);
  });
}
